import React from 'react';
import { useMutation } from '@apollo/client';
import { UPDATE_AGENT_PASSWORD } from 'store/mutations';
import AgentPortalError from 'errors/AgentPortalError';
import { passwordValid } from 'utils/password';
import { FormattedMessage } from 'react-intl';
import Field from 'components/ui/Field';
import ValidationForm from 'components/ui/ValidationForm';
import { StyledForm, StyledButton } from './ChangePasswordForm.styles';
import ChangePasswordFormSuccess from './ChangePasswordFormSuccess';

const inputFields = (invalidInputs, touchedInputs) => [
  {
    label: 'changePassword.currentPassword',
    name: 'currentPassword',
    type: 'password'
  },
  {
    hasError: invalidInputs.newPassword && touchedInputs.newPassword,
    errorMessage: 'changePassword.passwordStrength',
    label: 'changePassword.newPassword',
    name: 'newPassword'
  },
  {
    hasError: touchedInputs.confirmPassword && invalidInputs.confirmPassword,
    errorMessage: 'changePassword.passwordMismatch',
    label: 'changePassword.confirmPassword',
    name: 'confirmPassword'
  }
];

const ChangePasswordForm = () => {
  const [updateAgentPassword, { called, loading, error }] = useMutation(UPDATE_AGENT_PASSWORD);

  if (error) {
    throw new AgentPortalError(error);
  }

  return (
    <>
      {called && !loading ? (
        <ChangePasswordFormSuccess />
      ) : (
        <ValidationForm
          validators={{
            newPassword: (values) => passwordValid(values.newPassword),
            confirmPassword: (values) => values.confirmPassword === values.newPassword
          }}
          fields={{
            currentPassword: '',
            newPassword: '',
            confirmPassword: ''
          }}
        >
          {({ fields, invalidInputs, onChange, hasInvalidInputs, touchedInputs }) => (
            <StyledForm
              onSubmit={(data) => {
                updateAgentPassword({
                  variables: data
                });
              }}
            >
              {inputFields(invalidInputs, touchedInputs).map(({ name, label, hasError, errorMessage }) => (
                <Field
                  key={name}
                  onChange={onChange}
                  value={fields[name] || ''}
                  type="password"
                  {...{ label, name, hasError, errorMessage }}
                />
              ))}
              <StyledButton disabled={loading || !fields.currentPassword || hasInvalidInputs} type="submit">
                <FormattedMessage id="changePassword.cta" />
              </StyledButton>
            </StyledForm>
          )}
        </ValidationForm>
      )}
    </>
  );
};

export default ChangePasswordForm;
